<template>
  <div class="auth_cookie-usage" v-if="!cookieUsageAccepted">
    <p class="auth_cookie-usage__text">
      {{$t("cookie_usage.text")}}
    </p>
    <a class="auth_cookie-usage__link-to-politics" target="_blank" :href="`${authTarget}/static/rule/security_politics`">
      {{$t("cookie_usage.link_to_policy")}}
    </a><div class="button blue auth_cookie-usage__button" @click="close">
      {{$t("cookie_usage.close")}}
    </div>
  </div>
</template>

<script>
  const cookieUsageLocalStorageKey = "CookieUsageAccepted";

  export default {
    name: "CookieUsage",
    data() {
      return {
        cookieUsageAccepted: localStorage.getItem(cookieUsageLocalStorageKey) || true,
        authTarget: envs.authTarget
      }
    },
    methods: {
      close() {
        localStorage.setItem(cookieUsageLocalStorageKey, this.cookieUsageAccepted = 1);
      }
    }
  }
</script>
